export function getHighestReachedMilestone(watchedPercent, milestones) {
  const normalized = Number.isFinite(watchedPercent) ? Math.max(0, Math.min(100, watchedPercent)) : 0;
  let highest = null;
  for (const milestone of milestones) {
    if (normalized >= milestone) {
      highest = milestone;
    }
  }
  return highest;
}

export function getNextMilestonesToReport(maxSent, watchedPercent, milestones) {
  const highest = getHighestReachedMilestone(watchedPercent, milestones);
  if (highest === null || highest <= maxSent) {
    return [];
  }

  return milestones.filter((milestone) => milestone > maxSent && milestone <= highest);
}
